<template>
  <div class="pdf-signer-app">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link
      href="https://fonts.googleapis.com/css2?family=Allura&family=Dancing+Script:wght@400..700&family=Pacifico&family=Sacramento&family=Satisfy&display=swap"
      rel="stylesheet">
    <div v-if="showSavedSignatures" class="signature-modal">
      <div class="modal-content">
        <h3>Mis Firmas Guardadas</h3>
        <div v-if="savedSignatures.length === 0" class="empty-state">
          <i class="fas fa-signature fa-3x"></i>
          <p>Aún no has guardado ninguna firma</p>
        </div>
        <div v-else class="saved-signatures-list">
          <a-list item-layout="horizontal" :data-source="savedSignatures">
            <a-list-item slot="renderItem" slot-scope="signature, index">
              <img :src="signature.data" class="signature-preview" @click="useSavedSignature(signature)"/>

              <a slot="actions">
                <div class="signature-meta">
                  <div class="signature-actions">
                    <a-button @click="deleteSavedSignature(signature.id)" icon="delete" type="danger" size="small">
                      Eliminar {{ signature.name }}
                    </a-button>
                  </div>
                </div>
              </a>
            </a-list-item>
          </a-list>
        </div>
        <div class="modal-actions">
          <a-button
            @click="showSavedSignatures = false"
            type="primary"
          >
            Cerrar
          </a-button>
          <a-button
            @click="toggleSignaturePad"
            icon="plus"
            type="default"
          >
            Crear Nueva Firma
          </a-button>
        </div>
      </div>
    </div>
    <!-- Sidebar con miniaturas -->
    <div class="sidebar" v-show="pdfDoc">
      <div
        v-for="(page, index) in pdfPages"
        :key="index"
        class="thumbnail"
        :class="{ 'active': currentPage === index }"
        @click="goToPage(index)"
      >
        <canvas :ref="`thumb_${index}`"></canvas>
        <div class="page-number">Pág. {{ index + 1 }}</div>
      </div>
    </div>

    <!-- Main content -->
    <div class="main-content">
      <!-- Toolbar superior -->
      <div class="toolbar">
        <div>
          <form-model-dropdown style="width: 100%" endpoint="hierarchy_lookup"
                               :params="{h_lookup_type: 'DOCUMENTOS_DIGITALES'}"
                               :selectedObj.sync="attSelected"></form-model-dropdown>

          <a-button @click="selectDocument" :disabled="!documentSelected" style="width: 100%; margin-top: 10px"
                    icon="file-pdf" :loading="loadingPdf">
            Seleccionar Documento
          </a-button>
        </div>
        <!--<div class="file-upload-container" v-if="pdfDoc"
             @dragover.prevent="dragOverPdf = true"
             @dragleave="dragOverPdf = false"
             @drop.prevent="handlePdfDrop($event)"
             :class="{ 'drag-active': dragOverPdf, 'has-file': pdfFile }">
          <input type="file"
                 id="pdf-upload"
                 @change="loadPdf"
                 accept="application/pdf"
                 class="file-input-hidden"/>

          <label for="pdf-upload" class="file-upload-label">
            <i class="fas" :class="pdfFile ? 'fa-file-pdf' : 'fa-cloud-upload-alt'"></i>
            <span v-if="!pdfFile">Arrastra tu PDF aquí o haz clic</span>
            <span v-else class="file-name">{{ pdfFile.name }}</span>
            <div class="upload-progress" :style="{ width: pdfProgress + '%' }"></div>
          </label>
        </div>-->
        <div class="file-upload-container signature-upload"
             @dragover.prevent="dragOverImage = true"
             @dragleave="dragOverImage = false"
             @drop.prevent="handleImageDrop($event)"
             :class="{ 'drag-active': dragOverImage, 'has-file': signatureFile }">
          <input type="file"
                 id="signature-upload"
                 @change="loadSignatureImage"
                 accept="image/*"
                 class="file-input-hidden"/>

          <label for="signature-upload" class="file-upload-label">
            <i class="fas" :class="signatureFile ? 'fa-file-image' : 'fa-signature'"></i>
            <span v-if="!signatureFile">Arrastra tu firma o haz clic</span>
            <span v-else class="file-name">{{ signatureFile.name }}</span>
            <div class="upload-progress" :style="{ width: imageProgress + '%' }"></div>
          </label>
        </div>
        <div class="button-group-container" v-show="pdfDoc">
          <div class="button-row">
            <a-button @click="toggleSignaturePad" icon="highlight" type="default" class="custom-btn">
              Firmar
            </a-button>
            <a-button type="primary" shape="circle" icon="folder" @click="showSavedSignatures = true"
                      style="background: #e9b513; color: white"/>
          </div>
          <div class="button-row">
            <a-button @click="sendSignedPdf" icon="file-pdf" type="primary" class="custom-btn" :loading="loadingSave">
              Guardar PDF
            </a-button>
            <a-button @click="clearAllSignatures" type="danger" icon="delete" class="custom-btn">
              Limpiar firmas
            </a-button>
          </div>
          <a-button @click="saveSignedPdf" icon="download">
            Descargar copia
          </a-button>
        </div>
        <div class="page-controls" v-show="pdfDoc">
          <button @click="prevPage" :disabled="currentPage === 0" class="btn-nav">
            <i class="fas fa-chevron-left"></i>
          </button>
          <span class="page-info">Página {{ currentPage + 1 }} de {{ pdfPages.length }}</span>
          <button @click="nextPage" :disabled="currentPage >= pdfPages.length - 1" class="btn-nav">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="pdf-viewer">
        <a-result v-if="!pdfDoc" status="404" title="¡Comienza a firmar tu PDF!"
                  sub-title="Selecciona tu documento aquí para empezar a firmarlo">
          <!--<template #extra>
            <div class="file-upload-container"
                 @dragover.prevent="dragOverPdf = true"
                 @dragleave="dragOverPdf = false"
                 @drop.prevent="handlePdfDrop($event)"
                 :class="{ 'drag-active': dragOverPdf, 'has-file': pdfFile }">
              <input type="file"
                     id="pdf-upload-primary"
                     @change="loadPdf"
                     accept="application/pdf"
                     class="file-input-hidden"/>

              <label for="pdf-upload-primary" class="file-upload-label">
                <i class="fas" :class="pdfFile ? 'fa-file-pdf' : 'fa-cloud-upload-alt'"></i>
                <span v-if="!pdfFile">Arrastra tu PDF aquí o haz clic</span>
                <span v-else class="file-name">{{ pdfFile.name }}</span>
                <div class="upload-progress" :style="{ width: pdfProgress + '%' }"></div>
              </label>
            </div>
          </template>-->
        </a-result>

        <div class="pdf-viewer-container" v-show="pdfDoc">
          <div class="pdf-container">
            <canvas ref="pdfCanvas" class="pdf-canvas"></canvas>
            <div
              class="signature-layer"
              :style="{
    width: ($refs.pdfCanvas ? $refs.pdfCanvas.width + 'px' : '0'),
    height: ($refs.pdfCanvas ? $refs.pdfCanvas.height + 'px' : '0')
  }"
            >
              <div
                v-for="(signature, index) in visibleSignatures"
                :key="index"
                class="signature-item"
                :class="{ 'dragging': currentDraggedSig === signature }"
                :style="{
                left: `${signature.x}px`,
                top: `${signature.y}px`,
                width: `${signature.width}px`,
                'z-index': 10
              }"
                @mousedown="startDrag($event, signature)"
                @click.stop
                @wheel.prevent="resizeSignature($event, signature)"
              >
                <img :src="signature.data" class="signature-img"/>
                <div class="resize-handle right" @mousedown.stop="startResize($event, signature, 'right')"></div>
                <div class="resize-handle corner" @mousedown.stop="startResize($event, signature, 'corner')"></div>
                <!-- Botón de eliminar -->
                <span class="delete-signature" @mousedown.stop="removeSignature(signature)">
    <i class="fas fa-times"></i>
  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Signature Pad Modal -->
    <div v-if="showSignaturePad" class="signature-modal">
      <div class="modal-content">
        <h3>Dibuja tu firma</h3>

        <!-- Selector de modo (firma/texto) -->
        <div class="pen-options">
          <a-radio-group v-model="signatureMode" button-style="solid">
            <a-radio-button value="draw">Dibujar</a-radio-button>
            <a-radio-button value="text">Texto</a-radio-button>
          </a-radio-group>
        </div>

        <!-- Opciones para dibujo -->
        <div v-show="signatureMode === 'draw'" class="drawing-options">
          <div class="pen-options">
            <span>Grosor: </span>
            <a-slider v-model="penSize" :min="2" :max="10" :step="0.5" style="width: 150px; margin: 0 10px"/>
            <span>{{ penSize }}px</span>
          </div>
        </div>

        <!-- Opciones para texto -->
        <div v-show="signatureMode === 'text'" class="text-options">
          <div class="pen-options">
            <span>Fuente: </span>
            <a-select v-model="textFont" style="width: 150px">
              <a-select-option v-for="font in availableFonts" :key="font" :value="font">
                {{ font }}
              </a-select-option>
            </a-select>
          </div>

          <div class="pen-options">
            <span>Tamaño: </span>
            <a-slider v-model="textSize" :min="70" :max="110" :step="1" style="width: 150px; margin: 0 10px"/>
            <span>{{ textSize }}px</span>
          </div>
        </div>

        <!-- Selector de color con paleta completa -->
        <div class="pen-options">
          <span>Color: </span>
          <sign-color-picker v-model="penColor" :colors="colorPalette"/>
        </div>

        <!-- Canvas para firma -->
        <canvas
          ref="signaturePad"
          class="signature-canvas"
          v-show="signatureMode === 'draw'"
        ></canvas>

        <!-- Input para texto -->
        <a-textarea :style="{fontFamily: textFont, fontSize: textSize + 'px', color: penColor}"
                    placeholder="Escribe tu nombre o firma"
                    v-show="signatureMode === 'text'"
                    v-model="signatureText"/>

        <div class="modal-actions">
          <a-button @click="saveSignature" icon="bg-colors" type="primary">
            Usar y guardar
          </a-button>
          <a-button @click="clearSignature" type="danger" icon="delete">
            Limpiar
          </a-button>
          <a-button style="background: black; color: white" @click="toggleSignaturePad" icon="close">
            Cancelar
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { PDFDocument, rgb } from 'pdf-lib'
  import * as pdfjsLib from 'pdfjs-dist/build/pdf'
  import SignaturePad from 'signature_pad'
  import './SignPdf.css'
  import Mensajes from '../../Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.min.js'

  export default {
    name: 'PdfSigner',
    data () {
      return {
        attSelected: {},
        loadingSave: false,
        loadingPdf: false,
        documentSelected: undefined,
        pdfDoc: null,
        pdfPages: [],
        currentPage: 0,
        scale: 1.5,
        signatures: [],
        activeSignature: null,
        showSignaturePad: false,
        signaturePad: null,
        currentDraggedSig: null,
        dragOffsetX: 0,
        dragOffsetY: 0,
        dragStartX: 0,
        dragStartY: 0,
        originalX: 0,
        originalY: 0,
        currentMouseX: 0,
        currentMouseY: 0,
        animateDrag: null,
        currentResizedSig: null,
        resizeDirection: null,
        originalWidth: 0,
        originalHeight: 0,
        resizeStartX: 0,
        resizeStartY: 0,
        dragOverPdf: false,
        dragOverImage: false,
        pdfFile: null,
        signatureFile: null,
        pdfProgress: 0,
        imageProgress: 0,
        currentRenderTask: null,
        savedSignatures: [],
        showSavedSignatures: false,
        selectedSavedSignature: null,
        penSize: 2,
        penColor: 'black',
        signatureMode: 'draw', // 'draw' o 'text'
        signatureText: '',
        textFont: 'Arial',
        textSize: 70,
        availableFonts: [
          'Arial',
          'Allura',
          'Dancing Script',
          'Pacifico',
          'Sacramento',
          'Satisfy',
          'Lucida Handwriting',
          'Segoe Print',
          'Comic Sans MS',
          'Times New Roman',
          'Courier New',
          'Georgia',
          'Impact',
          'Verdana'
        ],
        colorPalette: [
          '#000000', '#FFFFFF', '#FF0000', '#00FF00', '#0000FF',
          '#FFFF00', '#00FFFF', '#FF00FF', '#C0C0C0', '#808080',
          '#800000', '#808000', '#008000', '#800080', '#008080',
          '#000080', '#FFA500', '#A52A2A', '#FFC0CB', '#FFD700'
        ],
        penColors: {
          black: 'rgb(0, 0, 0)',
          blue: 'rgb(0, 0, 255)',
          red: 'rgb(255, 0, 0)',
          penColor: '#000000'
        }
      }
    },
    computed: {
      visibleSignatures () {
        return this.signatures.filter(sig => sig.page === this.currentPage)
      }
    },
    methods: {

      startResize (event, signature, direction) {
        this.currentResizedSig = signature
        this.resizeDirection = direction
        this.originalWidth = signature.width
        this.originalHeight = signature.width * 0.5
        this.resizeStartX = event.clientX
        this.resizeStartY = event.clientY

        document.addEventListener('mousemove', this.handleResize)
        document.addEventListener('mouseup', this.stopResize)
        event.preventDefault()
      },

      async selectDocument () {
        try {
          this.loadingPdf = true
          const response = await this.httpClient.getInstance().post(
            'greports/generateByCode',
            {code: this.documentSelected},
            {responseType: 'arraybuffer'}
          )
          this.pdfFile = new Blob([response.data], {type: 'application/pdf'})
          const arrayBuffer = await new Response(this.pdfFile).arrayBuffer()
          const loadingTask = pdfjsLib.getDocument(arrayBuffer)
          const pdf = await loadingTask.promise
          this.pdfPages = Array(pdf.numPages).fill(null)
          this.pdfDoc = await PDFDocument.load(arrayBuffer)
          this.$nextTick(() => {
            this.renderThumbnails(pdf)
            this.renderCurrentPage()
          })
          this.loadingPdf = false
        } catch (error) {
          console.error('Error loading PDF:', error)
          Mensajes.error('Error', 'No fue posible cargar el archivo.')
          this.loadingPdf = false
        }
      },

      handleResize (event) {
        if (!this.currentResizedSig) return

        const deltaX = event.clientX - this.resizeStartX
        const deltaY = event.clientY - this.resizeStartY

        if (this.resizeDirection === 'right' || this.resizeDirection === 'corner') {
          this.currentResizedSig.width = Math.max(50, this.originalWidth + deltaX)
        }
        if (this.resizeDirection === 'corner') {
        }
      },

      stopResize () {
        this.currentResizedSig = null
        this.resizeDirection = null
        document.removeEventListener('mousemove', this.handleResize)
        document.removeEventListener('mouseup', this.stopResize)
      },
      async loadPdf (event) {
        const file = event.target.files[0]
        if (!file) return

        try {
          this.pdfFile = file
          await this.simulateUpload('pdf')

          const arrayBuffer = await file.arrayBuffer()
          const loadingTask = pdfjsLib.getDocument(arrayBuffer)
          const pdf = await loadingTask.promise

          this.pdfPages = Array(pdf.numPages).fill(null)
          this.pdfDoc = await PDFDocument.load(arrayBuffer)

          this.$nextTick(() => {
            this.renderThumbnails(pdf)
            this.renderCurrentPage()
          })

        } catch (error) {
          console.error('Error loading PDF:', error)
          alert('Error al cargar el PDF. Asegúrate de que es un archivo válido.')
        }
      },

      async renderThumbnails (pdf) {
        for (let i = 0; i < this.pdfPages.length; i++) {
          const page = await pdf.getPage(i + 1)
          const viewport = page.getViewport({scale: 0.3})

          const canvas = this.$refs[`thumb_${i}`][0]
          const context = canvas.getContext('2d')
          canvas.height = viewport.height
          canvas.width = viewport.width

          await page.render({
            canvasContext: context,
            viewport: viewport
          }).promise
        }
      },

      async renderCurrentPage () {
        if (!this.pdfPages.length || !this.pdfDoc) return

        if (this.currentRenderTask) {
          await this.currentRenderTask.cancel()
        }

        const canvas = this.$refs.pdfCanvas
        const context = canvas.getContext('2d')

        context.clearRect(0, 0, canvas.width, canvas.height)

        try {
          const pdfBytes = await this.pdfDoc.save()
          const loadingTask = pdfjsLib.getDocument({data: pdfBytes})
          const pdf = await loadingTask.promise

          const page = await pdf.getPage(this.currentPage + 1)

          let containerWidth = 800

          const container = document.querySelector('.pdf-viewer-container')
          if (container && container.offsetWidth) {
            containerWidth = container.offsetWidth
          }

          const viewport = page.getViewport({scale: 1.0})
          const scale = Math.min(1.0, (containerWidth - 40) / viewport.width)

          const scaledViewport = page.getViewport({scale: scale})

          canvas.height = scaledViewport.height
          canvas.width = scaledViewport.width

          this.currentRenderTask = page.render({
            canvasContext: context,
            viewport: scaledViewport
          })

          await this.currentRenderTask.promise

        } catch (error) {
          if (error.name === 'RenderingCancelledException') {
            console.log('Renderizado cancelado intencionalmente')
          } else {
            console.error('Error al renderizar:', error)
          }
        } finally {
          this.currentRenderTask = null
        }
      },

      goToPage (pageIndex) {
        if (this.currentPage === pageIndex) return
        this.currentPage = pageIndex

        if (this.currentRenderTask) {
          this.currentRenderTask.cancel()
        }

        this.renderCurrentPage()
      },

      prevPage () {
        if (this.currentPage > 0) {
          this.currentPage--
          this.renderCurrentPage()
        }
      },

      nextPage () {
        if (this.currentPage < this.pdfPages.length - 1) {
          this.currentPage++
          this.renderCurrentPage()
        }
      },

      toggleSignaturePad () {
        this.showSignaturePad = !this.showSignaturePad
        this.signatureText = ''
        if (this.showSignaturePad) {
          this.$nextTick(() => {
            this.initSignaturePad()
          })
        }
      },

      initSignaturePad () {
        this.signatureText = ''
        const canvas = this.$refs.signaturePad
        canvas.width = canvas.offsetWidth
        canvas.height = canvas.offsetHeight

        this.signaturePad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(0, 0, 0, 0)',
          penColor: this.penColors[this.penColor],
          minWidth: this.penSize,
          maxWidth: this.penSize
        })
      },

      clearSignature () {
        if (this.signatureMode === 'draw' && this.signaturePad) {
          this.signaturePad.clear()
        } else {
          this.signatureText = ''
        }
      },

      async saveSignature () {
        let signatureData

        if (this.signatureMode === 'draw') {
          if (this.signaturePad.isEmpty()) {
            this.$message.error('Por favor dibuja tu firma primero')
            return
          }
          signatureData = this.signaturePad.toDataURL()
        } else {
          if (!this.signatureText.trim()) {
            this.$message.error('Por favor escribe tu texto')
            return
          }

          const canvas = document.createElement('canvas')
          const padding = 20
          const ctx = canvas.getContext('2d')

          ctx.font = `${this.textSize}px ${this.textFont}`
          const textWidth = ctx.measureText(this.signatureText).width
          canvas.width = textWidth + padding * 2
          canvas.height = this.textSize * 1.5 + padding * 2

          ctx.font = `${this.textSize}px ${this.textFont}`
          ctx.fillStyle = this.penColor
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(this.signatureText, canvas.width / 2, canvas.height / 2)

          signatureData = canvas.toDataURL()
        }

        this.activeSignature = {
          data: signatureData,
          width: this.signatureMode === 'text' ? 200 : 150,
          x: 50,
          y: 50,
          page: this.currentPage,
          type: this.signatureMode,
          font: this.textFont,
          size: this.textSize,
          color: this.penColor
        }

        this.signatures.push({...this.activeSignature})
        this.saveCurrentSignature()
        this.toggleSignaturePad()

        if (this.signaturePad) {
          this.signaturePad.clear()
        }
        this.signatureText = ''
      },

      async loadSignatureImage (event) {
        const file = event.target.files[0]
        if (!file) return

        this.signatureFile = file
        await this.simulateUpload('image')

        const reader = new FileReader()
        reader.onload = (e) => {
          this.activeSignature = {
            data: e.target.result,
            width: 150,
            x: 50,
            y: 50,
            page: this.currentPage
          }
          this.signatures.push({...this.activeSignature})
        }
        reader.readAsDataURL(file)
      },

      startDrag (event, signature) {
        if (event.target.closest('.delete-signature')) return

        this.currentDraggedSig = signature
        const canvas = this.$refs.pdfCanvas
        const rect = canvas.getBoundingClientRect()

        this.dragStartX = event.clientX
        this.dragStartY = event.clientY
        this.originalX = signature.x
        this.originalY = signature.y

        this.handleDragMove(event)

        document.addEventListener('mousemove', this.handleDragMove)
        document.addEventListener('mouseup', this.stopDrag)
        event.preventDefault()
      },

      handleDragMove (event) {
        if (!this.currentDraggedSig) return

        const deltaX = event.clientX - this.dragStartX
        const deltaY = event.clientY - this.dragStartY

        const canvas = this.$refs.pdfCanvas
        const maxX = canvas.width - this.currentDraggedSig.width
        const maxY = canvas.height - (this.currentDraggedSig.width * 0.5)

        this.currentDraggedSig.x = Math.max(0, Math.min(this.originalX + deltaX, maxX))
        this.currentDraggedSig.y = Math.max(0, Math.min(this.originalY + deltaY, maxY))
      },

      updateMousePosition (event) {
        this.currentMouseX = event.clientX
        this.currentMouseY = event.clientY
      },

      endDrag () {
        this.currentDraggedSig = null
        cancelAnimationFrame(this.animateDrag)
        document.removeEventListener('mousemove', this.updateMousePosition)
        document.removeEventListener('mouseup', this.endDrag)
      },

      dragMove (event) {
        if (!this.currentDraggedSig) return

        const canvas = this.$refs.pdfCanvas
        const rect = canvas.getBoundingClientRect()

        const x = event.clientX - rect.left - this.dragOffsetX
        const y = event.clientY - rect.top - this.dragOffsetY

        const maxX = canvas.width - this.currentDraggedSig.width
        const maxY = canvas.height - (this.currentDraggedSig.width * 0.5) // Aprox. relación de aspecto

        this.currentDraggedSig.x = Math.max(0, Math.min(x, maxX))
        this.currentDraggedSig.y = Math.max(0, Math.min(y, maxY))
      },

      resizeSignature (signature, delta) {
        if (signature && typeof signature === 'object') {
          const newWidth = signature.width + delta
          signature.width = Math.max(50, Math.min(500, newWidth)) // Límites de 50 a 500px
        }
      },

      removeSignature (signature) {
        this.stopDrag()
        this.stopResize()

        this.signatures = this.signatures.filter(sig => {
          return sig !== signature
        })
      },

      stopDrag () {
        this.currentDraggedSig = null
        document.removeEventListener('mousemove', this.handleDragMove)
        document.removeEventListener('mouseup', this.stopDrag)
      },

      clearAllSignatures () {
        if (confirm('¿Estás seguro de que quieres eliminar todas las firmas?')) {
          this.signatures = []
        }
      },

      async sendSignedPdf () {
        if (!this.pdfDoc) {
          Mensajes.error('Error', 'No hay PDF cargado o firmas agregadas')
          return
        }

        try {
          this.loadingSave = true
          const newPdfDoc = await PDFDocument.create()
          const pages = this.pdfDoc.getPages()

          for (let i = 0; i < pages.length; i++) {
            const [copiedPage] = await newPdfDoc.copyPages(this.pdfDoc, [i])
            newPdfDoc.addPage(copiedPage)
          }

          for (const signature of this.signatures) {
            try {
              const page = newPdfDoc.getPage(signature.page)
              let image

              if (signature.data.startsWith('data:image/png')) {
                const pngBytes = await fetch(signature.data).then(res => res.arrayBuffer())
                image = await newPdfDoc.embedPng(pngBytes)
              } else {
                const imgBytes = await fetch(signature.data).then(res => res.arrayBuffer())
                image = await newPdfDoc.embedJpg(imgBytes)
              }

              const {width, height} = page.getSize()
              const scaleFactor = width / this.$refs.pdfCanvas.width

              const pdfX = signature.x * scaleFactor
              const pdfY = height - (signature.y * scaleFactor) - (signature.width * scaleFactor * (image.height / image.width))

              page.drawImage(image, {
                x: pdfX,
                y: pdfY,
                width: signature.width * scaleFactor,
                height: signature.width * scaleFactor * (image.height / image.width)
              })
            } catch (error) {
              console.error('Error al agregar firma:', error)
            }
          }

          const pdfBytes = await newPdfDoc.save()

          const formData = new FormData()
          const pdfBlob = new Blob([pdfBytes], {type: 'application/pdf'})
          formData.append('pdfSign', pdfBlob, 'documento_firmado.pdf')

          if (this.documentSelected) {
            formData.append('id_code', this.attSelected.value)
          }

          const response = await this.httpClient.getInstance().post('greports/saveReportByCode', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

          if (response.status === 200) {
            Mensajes.success('Correcto', 'PDF firmado guardado exitosamente')
            this.loadingSave = false
          } else {
            Mensajes.error('Error', 'No fue posible guardar el PDF firmado')
            this.loadingSave = false
          }

        } catch (error) {
          this.loadingSave = false
          Mensajes.error('Error', 'Ocurrió un error al enviar el PDF firmado')
          return null
        }
      },

      async saveSignedPdf () {
        if (!this.pdfDoc) {
          alert('No hay PDF cargado o firmas agregadas')
          return
        }

        try {
          const newPdfDoc = await PDFDocument.create()
          const pages = this.pdfDoc.getPages()

          for (let i = 0; i < pages.length; i++) {
            const [copiedPage] = await newPdfDoc.copyPages(this.pdfDoc, [i])
            newPdfDoc.addPage(copiedPage)
          }

          for (const signature of this.signatures) {
            try {
              const page = newPdfDoc.getPage(signature.page)
              let image

              if (signature.data.startsWith('data:image/png')) {
                const pngBytes = await fetch(signature.data).then(res => res.arrayBuffer())
                image = await newPdfDoc.embedPng(pngBytes)
              } else {
                const imgBytes = await fetch(signature.data).then(res => res.arrayBuffer())
                image = await newPdfDoc.embedJpg(imgBytes)
              }

              const {width, height} = page.getSize()
              const scaleFactor = width / this.$refs.pdfCanvas.width

              const pdfX = signature.x * scaleFactor
              const pdfY = height - (signature.y * scaleFactor) - (signature.width * scaleFactor * (image.height / image.width))

              page.drawImage(image, {
                x: pdfX,
                y: pdfY,
                width: signature.width * scaleFactor,
                height: signature.width * scaleFactor * (image.height / image.width)
              })

            } catch (error) {
              console.error('Error al agregar firma:', error)
            }
          }

          const pdfBytes = await newPdfDoc.save()
          this.downloadPdf(pdfBytes)

        } catch (error) {
          console.error('Error al guardar el PDF:', error)
          alert('Error al guardar el PDF. Por favor intenta nuevamente.')
        }
      },

      downloadPdf (pdfBytes) {
        const blob = new Blob([pdfBytes], {type: 'application/pdf'})
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'documento_firmado.pdf'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      },
      async handlePdfDrop (e) {
        this.dragOverPdf = false
        const file = e.dataTransfer.files[0]
        if (file && file.type === 'application/pdf') {
          this.pdfFile = file
          await this.simulateUpload('pdf')
          this.loadPdf({target: {files: [file]}})
        }
      },

      async handleImageDrop (e) {
        this.dragOverImage = false
        const file = e.dataTransfer.files[0]
        if (file && file.type.match('image.*')) {
          this.signatureFile = file
          await this.simulateUpload('image')
          this.loadSignatureImage({target: {files: [file]}})
        }
      },

      simulateUpload (type) {
        return new Promise(resolve => {
          let progress = 0
          const interval = setInterval(() => {
            progress += Math.random() * 10
            if (type === 'pdf') {
              this.pdfProgress = Math.min(progress, 100)
            } else {
              this.imageProgress = Math.min(progress, 100)
            }

            if (progress >= 100) {
              clearInterval(interval)
              setTimeout(() => {
                if (type === 'pdf') this.pdfProgress = 0
                else this.imageProgress = 0
                resolve()
              }, 300)
            }
          }, 100)
        })
      },
      saveCurrentSignature () {
        if (!this.activeSignature) return

        const signatureCopy = {
          id: Date.now(),
          data: this.activeSignature.data,
          name: `Firma ${this.savedSignatures.length + 1}`,
          createdAt: new Date().toISOString()
        }

        const exists = this.savedSignatures.some(
          sig => sig.data === this.activeSignature.data
        )

        if (!exists) {
          this.savedSignatures.push(signatureCopy)
          localStorage.setItem('savedSignatures', JSON.stringify(this.savedSignatures))
          this.$message.success('Firma guardada en tu biblioteca')
        } else {
          this.$message.info('Esta firma ya estaba guardada')
        }
      },

      loadSavedSignatures () {
        const saved = localStorage.getItem('savedSignatures')
        if (saved) {
          this.savedSignatures = JSON.parse(saved)
        }
      },

      useSavedSignature (signature) {
        this.activeSignature = {
          data: signature.data,
          width: 150,
          x: 50,
          y: 50,
          page: this.currentPage
        }
        this.signatures.push({...this.activeSignature})
        this.showSavedSignatures = false
      },

      deleteSavedSignature (id) {
        this.savedSignatures = this.savedSignatures.filter(sig => sig.id !== id)
        localStorage.setItem('savedSignatures', JSON.stringify(this.savedSignatures))
      }
    },
    watch: {
      attSelected () {
        if (this.attSelected) {
          this.documentSelected = this.attSelected.code
        } else {
          this.documentSelected = undefined
        }
      },
      penSize () {
        if (this.signaturePad) {
          this.signaturePad.minWidth = this.penSize
          this.signaturePad.maxWidth = this.penSize
          this.signaturePad.penColor = this.penColor
        }
      },
      penColor () {
        if (this.signaturePad) {
          this.signaturePad.penColor = this.penColor
          this.signaturePad.minWidth = this.penSize
          this.signaturePad.maxWidth = this.penSize
        }
      },
      signatureMode () {
        this.$nextTick(() => {
          if (this.$refs.signaturePad) {
            this.initSignaturePad()
          }
        })
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadSavedSignatures()
      this.$nextTick(() => {
        if (this.$refs.signaturePad) {
          this.initSignaturePad()
        }
      })
    },
    beforeDestroy () {
      document.removeEventListener('mousemove', this.dragMove)
      document.removeEventListener('mouseup', this.endDrag)
      if (this.currentRenderTask) {
        this.currentRenderTask.cancel()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/SignPDF/SignPdf.vue